import React, { useEffect } from "react";
import { Button, Modal, Space, Typography } from "antd";
import { SyncOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import { useVersion } from "../../../data/hooks/version/useVersion";
import { useTranslation } from "react-i18next";
import { isServiceWorkerScopePath } from "../../../serviceWorker";

const { Title, Text } = Typography;

const UpdateAvailableModal = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { updateAvailable, applyUpdate, dismissUpdate, latestVersion } = useVersion();

  useEffect(() => {
    if (updateAvailable) {
      console.log("[UpdateModal] Update available, showing modal");
    }
  }, [updateAvailable]);

  if (!isServiceWorkerScopePath(location.pathname)) {
    return null;
  }

  return (
    <Modal open={updateAvailable} closable={false} footer={null} centered maskClosable={false} width={400}>
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <div style={{ textAlign: "center" }}>
          <SyncOutlined
            style={{
              fontSize: 48,
              color: "#1890ff",
              marginBottom: 16,
            }}
          />
          <Title level={4} style={{ margin: 0 }}>
            {t("update_available_title")}
          </Title>
        </div>

        <Text type="secondary" style={{ display: "block", textAlign: "center" }}>
          {t("update_available_description")}
        </Text>

        {latestVersion && (
          <Text
            type="secondary"
            style={{
              display: "block",
              textAlign: "center",
              fontSize: 12,
            }}
          >
            {t("new_version")}: {latestVersion}
          </Text>
        )}

        <Space style={{ width: "100%", justifyContent: "center" }} size="middle">
          <Button type="primary" onClick={applyUpdate} size="large">
            {t("update_now")}
          </Button>
          <Button onClick={dismissUpdate} size="large">
            {t("update_later")}
          </Button>
        </Space>

        <Text
          type="warning"
          style={{
            display: "block",
            textAlign: "center",
            fontSize: 11,
          }}
        >
          {t("update_warning")}
        </Text>
      </Space>
    </Modal>
  );
};

export default UpdateAvailableModal;
